import Cookies from "js-cookie"; // 引用 js-cookie 用於操作 Cookies
import api from "@/assets/js/api"; // 引用 API 模組
import Swal from "sweetalert2"; // 引入 SweetAlert2 用於彈出提示
import { parseJwt } from "@/assets/js/jwt"; // 引用你寫的 parseJwt 函式

export default {
  data() {
    return {
      currentPage: "dashboard", // 預設頁面
      pageTitle: "儀表板", // 頁面標題
      currentUser: "未命名用戶", // 預設的用戶名稱
    };
  },
  methods: {
    // 切換頁面
    navigateTo(page) {
      this.currentPage = page;
      const pageTitles = {
        dashboard: "儀表板",
        users: "用戶管理",
        orders: "訂單管理",
        settings: "設定",
      };
      this.pageTitle = pageTitles[page] || "儀表板";
    },

    // 從後端 API 獲取當前用戶的名稱
    async fetchCurrentUser() {
      try {
        // 🔐 1️⃣ 直接拿 token
        const token = Cookies.get("token");

        if (!token) {
          Swal.fire({
            icon: "warning",
            title: "未登入",
            text: "請重新登入！",
            confirmButtonText: "確定",
          });
          this.$router.push("/login");
          return;
        }

        // 🔓 2️⃣ 從 JWT 解析 email（唯一正確來源）
        const payload = parseJwt(token);
        const email = payload?.email;

        console.debug("[DEBUG] JWT Email:", email);

        if (!email) {
          Swal.fire({
            icon: "error",
            title: "登入資訊異常",
            text: "無法解析使用者 Email",
            confirmButtonText: "確定",
          });
          this.$router.push("/login");
          return;
        }

        // 📡 3️⃣ 呼叫後端 API
        const response = await api.get(`/Member/${email}`);

        if (response.status === 200) {
          this.currentUser = response.data.fullName;
          console.debug("[DEBUG] 使用者名稱:", this.currentUser);
        } else {
          Swal.fire({
            icon: "error",
            title: "資料取得失敗",
            text: "無法取得會員資料",
            confirmButtonText: "確定",
          });
        }
      } catch (error) {
        console.error("[ERROR] fetchCurrentUser:", error);
        Swal.fire({
          icon: "error",
          title: "系統錯誤",
          text: "取得會員資料時發生錯誤",
          confirmButtonText: "確定",
        });
      }
    },

    // 登出處理
    async handleLogout() {
      try {
        Cookies.remove("token"); // 移除 Token
        Cookies.remove("email"); // 移除 Email
        this.$router.push("/login"); // 跳轉到登入頁面
      } catch (error) {
        console.error("[ERROR] 登出失敗:", error.message);
        Swal.fire({
          icon: "error",
          title: "登出失敗",
          text: "請稍後再試！",
          confirmButtonText: "確定",
        });
      }
    },
    goHome() {
      this.$router.push("/"); // 跳轉到首頁
    },

    async fetchMember() {
      try {
        const token = Cookies.get("token");
        const payload = parseJwt(token);
        const currentEmail = payload?.email;

        if (!currentEmail) {
          Swal.fire({
            icon: "warning", // 警告圖示
            title: "未登入", // 標題
            text: "請重新登入！", // 提示文字
            confirmButtonText: "確定", // 確認按鈕
          });

          this.$router.push("/login");
          return;
        }

        console.debug("[DEBUG] 當前登入用戶 Email:", currentEmail);

        // 選取所有 nav-button 按鈕
        const buttons = document.querySelectorAll(".nav-button");

        // 為每個按鈕添加點擊事件監聽
        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            // 清除其他按鈕的 active 狀態
            buttons.forEach((btn) => btn.classList.remove("active"));
            // 為當前按鈕添加 active 狀態
            button.classList.add("active");
          });
        });

        // 使用 api.js 调用后端 API，直接根据 Email 获取用户数据
        const response = await api.get(`/Member/${currentEmail}`);

        if (response.status === 200) {
          this.member = response.data; // 保存后端返回的会员数据
          console.debug("[DEBUG] 當前會員資料:", this.member);
        } else {
          console.error("[DEBUG] 無法獲取會員資料:", response.data);
          Swal.fire({
            icon: "error", // 錯誤圖示
            title: "資料獲取失敗", // 標題
            text: "無法獲取會員資料！", // 提示文字
            confirmButtonText: "確定", // 按鈕文字
          });
        }
      } catch (error) {
        console.error(
          "[DEBUG] 獲取會員資料失敗:",
          error.response?.data || error.message
        );
        Swal.fire({
          icon: "error",
          title: "伺服器錯誤",
          text: "伺服器錯誤，無法獲取會員資料！",
          confirmButtonText: "確定",
        });
      }
    },
  },

  created() {
    // 頁面載入時調用 fetchCurrentUser
    this.fetchCurrentUser();
    // 模擬從 localStorage 獲取用戶資料
  },
};
